import React from 'react';
import Stars from 'atomic/utilization/stars';
import './product-offer-dealer-opinions-tooltip.scss';
import DealerOpinionsInterface from 'interfaces/dealer-opinions.interface';

interface ProductOfferDealerOpinionsTooltipProps {
    opinions: DealerOpinionsInterface;
}

const ProductOfferDealerOpinionsTooltip: React.FC<ProductOfferDealerOpinionsTooltipProps> = ({ opinions }) => (
    <div className="tooltip-offer">
        <div className="tooltip-offer__stars">
            <Stars className="md inline star-rating--filled star-rating--inline" width={opinions.average}/>
            <span className="tooltip-offer__stars-average">
                {opinions.average.toPrecision(3)}
            </span>
            <span className="tooltip-offer__stars-text">
                {' '}
                na podstawie
                {' '}
                {opinions.count}
                {' '}
                opinii klientów
            </span>
        </div>
        <b className="tooltip-offer__title">
            Szczegółowa ocena:
        </b>
        <dl className="tooltip-offer__list">
            <dd>
                {' '}
                Szybkość realizacji zamówienia
                <strong>
                    {opinions.details.realizationSpeed}
                </strong>
            </dd>
            <dd>
                {' '}
                Poziom obsługi klienta
                <strong>
                    {opinions.details.serviceQuality}
                </strong>
            </dd>
            <dd>
                {' '}
                Jakość zapakowania przesyłki
                <strong>
                    {opinions.details.packageQuality}
                </strong>
            </dd>
            <dd>
                {' '}
                Polecił(a) bym ten sklep znajomym
                <strong>
                    {opinions.details.recomendationLevel}
                </strong>
            </dd>
        </dl>
        <a
            className="tooltip-offer__link"
            href={opinions.url}
            rel="noopener noreferrer"
            target="_blank"
        >
            zobacz opinie o sklepie
        </a>
    </div>);

export default ProductOfferDealerOpinionsTooltip;
